import { domains } from "./environment";

export const DOMAINS = {
  CLIENT_PORTAL: domains.clientPortal,
};

export const getPlaidRedirectUrl = () =>
  `${DOMAINS.CLIENT_PORTAL}/kyc?plaid_success=true`;
